import { gql } from '@apollo/client';

export const SALE_POOL_LOANS_QUERY = gql`
  query SalePoolLoans(
    $saleId: ID!
    $offeringId: ID!
    $viewId: ID
    $viewJti: String
    $filters: [Filter!]
    $sort: SalePoolLoanSort
    $pagination: Pagination!
    $piiNoticeAcknowledged: Boolean
    $piiNoticeVersion: String
    $viewAs: SaleBidderLevel
  ) {
    salePoolLoans(
      sale_id: $saleId
      offering_id: $offeringId
      view_id: $viewId
      view_jti: $viewJti
      filters: $filters
      sort: $sort
      pagination: $pagination
      pii_notice_acknowledged: $piiNoticeAcknowledged
      pii_notice_version: $piiNoticeVersion
      view_as: $viewAs
    ) {
      __typename
      level
      total_count
      allowed_filter_fields
      allowed_sort_fields
      allowed_term_fields
      loans {
        __typename
        id
        account_id
        sale_key
        fund_number
        institution_id
        performance_status
        asset_class
        product
        state
        current_balance_cents
        original_balance_cents
        interest_rate_bps
        origination_date_seconds
        first_payment_date_seconds
        maturity_date_seconds
        next_payment_date_seconds
        loan_terms_months
        remaining_loan_terms_months
        age_months
        days_past_due
        ltv_bps
        dti_bps
        borrower_credit_score
        loan_number
        asset_name
        borrower_name
        borrower_type
        borrower_summary
        borrower_revolving_debt_cents
        guarantor_names
        collateral_name
        collateral_summary
        auto_vin
        property_description
      }
    }
  }
`;

export const SALE_POOL_LOAN_TERMS_QUERY = gql`
  query SalePoolLoanTerms(
    $saleId: ID!
    $offeringId: ID!
    $viewId: ID
    $viewJti: String
    $fields: [FilterableField!]!
    $piiNoticeAcknowledged: Boolean
    $piiNoticeVersion: String
    $viewAs: SaleBidderLevel
  ) {
    salePoolLoanTerms(
      sale_id: $saleId
      offering_id: $offeringId
      view_id: $viewId
      view_jti: $viewJti
      fields: $fields
      pii_notice_acknowledged: $piiNoticeAcknowledged
      pii_notice_version: $piiNoticeVersion
      view_as: $viewAs
    ) {
      __typename
      fieldName
      terms
    }
  }
`;
